// extracted by mini-css-extract-plugin
export var active = "_32-2";
export var errorDot = "_32-3";
export var sideNavContainer = "_32-0";
export var sideNavLink = "_32-1";